
    import * as React from 'react';

    const Share16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Share_16_svg__Icons/Share/16" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M4,14 L12,14 L12,9 L13,9 L13,15 L12,15 L4,15 L3,15 L3,9 L4,9 L4,14 Z" id="Share_16_svg__Combined-Shape" fillRule="nonzero" /><path d="M8.50507627,2.90839453 L8.50507627,11 L7.49492373,11 L7.49492373,2.92643251 L3.7233047,6.69805153 L3.01262658,5.98737342 L8.01262658,0.987373415 L8.7233047,1.69805153 L12.9873734,5.96212025 L12.2730877,6.67640596 L8.50507627,2.90839453 Z" id="Share_16_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Share16.displayName = 'Share16';

    export default Share16;
  